import {useTranslation} from "react-i18next";
import rygLogo from "../../../assets/images/ryg-logo03.png";

const logoRygCls = "[&_img]:w-[var(--size-100)] [&_img]:block [&_img]:mx-auto";
const tosContainerCls =
  "m-5 font-[var(--font-family)] leading-[1.6] [&_h2]:text-2xl [&_h2]:mb-[var(--space-3-75)] [&_h2]:text-white [&_p]:mb-[var(--space-3)] [&_strong]:font-bold [&_strong]:text-[var(--color-info)]";

const TermsOfService = () => {
  const {t} = useTranslation();

  return (
    <>
      <div className={logoRygCls}>
        <img
          src={rygLogo}
          alt="Ryg Logo"
        />
      </div>
      <div className={tosContainerCls}>
        <h2>{t("TOStitle")}</h2>
        <p>
          <strong>{t("TOSParagraphtitle")}</strong> {t("TOSParagraph")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle2")}</strong> {t("TOSParagraph2")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle3")}</strong> {t("TOSParagraph3")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle4")}</strong> {t("TOSParagraph4")}
        </p>
        <p>{t("TOSParagraph4_1")}</p>
        <p>{t("TOSParagraph4_2")}</p>
        <p>
          <strong>{t("TOSParagraphtitle5")}</strong> {t("TOSParagraph5")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle6")}</strong> {t("TOSParagraph6")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle7")}</strong> {t("TOSParagraph7")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle8")}</strong> {t("TOSParagraph8")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle9")}</strong> {t("TOSParagraph9")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle10")}</strong> {t("TOSParagraph10")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle11")}</strong> {t("TOSParagraph11")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle12")}</strong> {t("TOSParagraph12")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle13")}</strong> {t("TOSParagraph13")}
        </p>
        <p>
          <strong>{t("TOSParagraphtitle14")}</strong> {t("TOSParagraph14")}
        </p>
        <p>
          <strong>{t("TOSParagraphNote")}</strong> {t("TOSParagraphNoteContent")}
        </p>
        <h2>{t("TOSPolitics")}</h2>

        <p>
          <strong>1. {t("TOSPolitics_1")}</strong>
        </p>
        <ul>
          <li>{t("TOSPolitics_1_1")}</li>
          <li>{t("TOSPolitics_1_2")}</li>
          <li>{t("TOSPolitics_1_3")}</li>
        </ul>

        <p>
          <strong>2. {t("TOSPolitics_2")}</strong>
        </p>
        <ul>
          <li>{t("TOSPolitics_2_1")}</li>
          <li>{t("TOSPolitics_2_2")}</li>
          <li>{t("TOSPolitics_2_3")}</li>
        </ul>

        <p>
          <strong>3. {t("TOSPolitics_3")}</strong>
        </p>
        <ul>
          <li>{t("TOSPolitics_3_1")}</li>
          <li>{t("TOSPolitics_3_2")}</li>
        </ul>

        <p>
          <strong>4. {t("TOSPolitics_4")}</strong>
        </p>
        <ul>
          <li>{t("TOSPolitics_4_1")}</li>
          <li>{t("TOSPolitics_4_2")}</li>
        </ul>

        <p>
          <strong>5. {t("TOSPolitics_5")}</strong>
        </p>
        <p>{t("TOSPolitics_5_1")}</p>

        <p>
          <strong>6. {t("TOSPolitics_6")}</strong>
        </p>
        <p>{t("TOSPolitics_6_1")}</p>

        <p>
          <strong>{t("TOSPrivacyPolicy")}</strong>
        </p>
      </div>
    </>
  );
};

export default TermsOfService;
